import script from "./CourseListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseListView.vue?vue&type=script&setup=true&lang=ts"

import "./CourseListView.vue?vue&type=style&index=0&id=b7ed346e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7ed346e"]])

export default __exports__